











































































































































































































































































































import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import TaskApi from '@/api/task'
import addTaskMixin from './addTaskMixin'
import ImageUploads from './ImagesUploads.vue'

@Component({
	components: {
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
		ImageUploads,
	},
})
export default class OtherInvestigate extends Mixins(addTaskMixin) {
	private imageBlocks = [
		{
			name: '调查授权',
			type: '0d01',
			isMultiple: true, // 是否可多选
			required: true, // 是否必填，用于提交校验
			maxNum: 50,
		},
		{
			name: '被调查人身份证复印件',
			type: '0f01',
			isMultiple: true,
			required: true,
			maxNum: 50,
		},
		{
			name: '其他（可选）',
			type: '0900',
			isMultiple: true,
			required: false,
			maxNum: 50,
		},
	]

	private mediaMap: any = {}

	private handleMediaMapChange(checkedType: string, subMap: any) {
		this.$set(this.mediaMap, checkedType, subMap)
	}

	private onTypeCheck(checkedType: string) {
		let index = this.checkedTypeList.indexOf(checkedType)
		if (index > -1) {
			this.checkedTypeList.splice(index, 1)
			this.resetPoint(checkedType)
			this.resetFile(checkedType)
		} else {
			this.checkedTypeList.push(checkedType)
		}
	}

	private onTaskAdd() {
		if (this.uploading) {
			return this.$message.info('文件上传中')
		}
		this.addForm.validateFields((err: any, values: any) => {
			if (!err) {
				// validateFields存在异步校验
				// 避免快速多次的点击创建多个相同任务
				if (this.addLoading) {
					return
				}
				if (this.checkedTypeList.length <= 0) {
					return this.$message.error('请选择调查类型')
				}

				// 上传单证改为非必传
				// let unfinishIdx = this.checkedTypeList.findIndex(
				// 	(checkedType: string) => this.fileIdMap[checkedType].length <= 0
				// )
				// if (unfinishIdx > -1) {
				// 	return this.$message.error(
				// 		`请上传${
				// 			this.$store.state.setting.subTasktypeMap[
				// 				this.checkedTypeList[unfinishIdx]
				// 			]
				// 		}的上传单证`
				// 	)
				// }

				for (let checkedType of this.checkedTypeList) {
					const checkedItem = this.mediaMap[checkedType]
					for (let block of this.imageBlocks) {
						const blockImages = (checkedItem && checkedItem[block.type]) || []
						if (block.required && !(blockImages && blockImages.length > 0)) {
							return this.$message.error(
								`请上传${this.$store.state.setting.subTasktypeMap[checkedType]}的${block.name}`
							)
						}
					}
				}

				this.addLoading = true
				let taskList: any = []
				this.checkedTypeList.forEach((checkedType: string) => {
					const currentTask: any = cloneDeep(values.taskMap[checkedType])
					currentTask.subTaskType = checkedType

					const codes = currentTask.code.key.split('-')
					currentTask.provinceCode = codes[0]
					currentTask.cityCode = codes[1]
					currentTask.countryCode = codes[2]
					delete currentTask.code

					let pointList: string[] = []
					currentTask.pointIds.forEach((id: number) => {
						pointList.push(currentTask.pointMap[id])
					})
					currentTask.pointList = pointList
					delete currentTask.pointIds
					delete currentTask.pointMap

					let imageList: any[] = []
					const checkedMediaMap = this.mediaMap[checkedType]
					for (let block of this.imageBlocks) {
						const blockImages =
							(checkedMediaMap && checkedMediaMap[block.type]) || []
						imageList = imageList.concat(
							blockImages.map((imageObj: any) => ({
								picId: imageObj.picId,
								picName: imageObj.picName,
								type: block.type,
							}))
						)
					}
					currentTask.imageList = imageList

					if (this.fileIdMap[checkedType]) {
						currentTask.mediaList = this.fileIdMap[checkedType].map(
							(fileItem: any) => ({
								fileId: fileItem.fileId,
								fileName: fileItem.fileName,
							})
						)
					}
					taskList.push(currentTask)
				})

				let form = {
					...this.data,
					caseNo: values.caseNo,
					contact: values.contact,
					contactPhone: values.contactPhone,
					taskList,
					mediaInfo: values.mediaInfo,
				}
				TaskApi.addOtherInvestigate(form)
					.then((res: any) => {
						this.$message.success(res.message || '发布成功')
						this.resetPage()
						this.$multiTab.closeCurrentPage()
						this.$multiTab.open('/AiiTasks/TasksList')
					})
					.finally(() => {
						this.addLoading = false
					})
			} else {
				if (err.caseNo) {
					this.caseWaring = 'error'
					this.caseHelpMes = err.caseNo.errors[0].message
				}
			}
		})
	}
}
